"use client";

import { TextElementNova } from "@/components/ui-kit/TextElementNova/TextElementNova";
import { cn } from "@/utils/general";
import { segmentEvent } from "@/utils/segmentfunctions";

import { HomepageHeroLifestage, HomepageHeroTab } from "./HomepageHero.types";

type HomepageHeroTabsProps = {
  tabs: HomepageHeroTab[];
  active: HomepageHeroLifestage;
  setter: (value: HomepageHeroLifestage) => void;
};

const HomepageHeroTabs = ({ tabs, active, setter }: HomepageHeroTabsProps) => {
  const changeTab = (value: HomepageHeroLifestage, text: string) => {
    segmentEvent("Modal Tab Clicked", {
      module_location: "mid_fold",
      text,
    });
    setter(value);
  };

  return (
    <div className="relative z-[1] flex flex-row xl:flex-col justify-center gap-2">
      {tabs.map((tab) => {
        const selected = tab.value === active;
        return (
          <button
            key={tab.value}
            type="button"
            aria-label={tab.label}
            aria-current={selected ? "true" : undefined}
            className={cn(
              "w-1/3 max-w-[96px] md:max-w-[120px] xl:w-full xl:max-w-[171px]",
              "h-[34px] md:h-[42px] xl:h-14 px-3 xl:px-6 rounded",
              "bg-nova-base-solid-20 transition-colors hover:bg-nova-brand-accent-100",
              "active:bg-nova-base-black active:[&_.textelement]:text-nova-base-white",
              selected && "bg-nova-brand-accent-80 pointer-events-none"
            )}
            onClick={() => changeTab(tab.value, tab.label)}
          >
            <TextElementNova
              text={tab.label}
              className={cn(
                "CTA-20-Dia-Normal",
                selected ? "text-nova-base-black" : "text-nova-transparency-black-60"
              )}
            />
          </button>
        );
      })}
    </div>
  );
};

export default HomepageHeroTabs;
